import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getFacilityRooms = async (facilityId, statusId, searchString, floor) => {
  return await request.get(
    `/RentPlace/rental_house/${facilityId}/office`,
    { statusId, searchString, floor },
    'При загрузке помещений произошла ошибка',
    []
  );
};

const useRooms = (facilityId, statusId, searchString, floor) =>
  useQuery(
    [queries.roomsInFacility, facilityId, statusId, searchString, floor],
    () => getFacilityRooms(facilityId, statusId, searchString, floor),
    {
      placeholderData: [],
    }
  );

export default useRooms;
